export function addPeriodToDate(refillPeriod: number): string {
  const date = new Date();
  const finalDate = date.setDate(date.getDate() + refillPeriod);

  return new Date(finalDate).toString();
}
